import React from 'react';
import { RequesterProvider } from '../../context/RequesterContext';
import RequesterNav from './RequesterNav';
import RequesterHero from './RequesterHero';
import RequesterTrustModel from './RequesterTrustModel';
import RequesterThreePartModel from './RequesterThreePartModel';
import RequesterFeatures from './RequesterFeatures';
import RequesterStats from './RequesterStats';
import RequesterCTA from './RequesterCTA';
import RequesterRequestModal from './RequesterRequestModal';
import RequesterFooter from './RequesterFooter';

const Requester = () => (
  <RequesterProvider>
    <div className="min-h-screen bg-white flex flex-col" style={{ fontFamily: '"Roboto", sans-serif', overflowX: 'hidden' }}>
      <RequesterNav />
      <div className="flex-1">
        <RequesterHero />
        {/* <RequesterTrustModel />
        <RequesterThreePartModel /> */}
        {/* <RequesterFeatures />
        <RequesterStats />
        <RequesterCTA /> */}
        <RequesterRequestModal />
      </div>
      <RequesterFooter />
    </div>
  </RequesterProvider>
);

export default Requester;
